var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-small"}},[(_vm.loading)?[_vm._m(0),(_vm.show_text)?_c('div',{staticClass:"d-flex flex-justify-center pt-2"},[_c('span',[_vm._v(_vm._s(_vm.text)+"...")])]):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-justify-center"},[_c('div',{attrs:{"data-role":"activity","data-type":"cycle","data-style":"color"}})])
}]

export { render, staticRenderFns }